import { ReactElement, useState } from 'react';
import { CircularProgress } from '@mui/material';

import { useRequest } from '~hooks/useRequest';
import { getUsersWithDrivers } from '~services/route';
import { RouteUserBasic } from '~services/route/types';

import { DialogModifyAssignmentOrdersProps } from './types';
import DialogModifyAssignmentContentOrders from './content';
import {
  DialogModifyAssignmentOrdersContainer,
  DialogModifyAssignmentOrdersLoadingContainer,
} from './styles';

const DialogModifyAssignmentOrders = ({
  open,
  ...restProps
}: DialogModifyAssignmentOrdersProps): ReactElement => {
  const [users, setUsers] = useState<RouteUserBasic[]>([]);

  const [, loadingUsers] = useRequest({
    request: getUsersWithDrivers,
    payload: null,
    withPostSuccess: (response) => {
      const currentUsersResponse = response.data?.data
        .results as RouteUserBasic[];

      setUsers(currentUsersResponse);
    },
  });

  return (
    <DialogModifyAssignmentOrdersContainer open={open} maxWidth="md">
      {loadingUsers && (
        <DialogModifyAssignmentOrdersLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogModifyAssignmentOrdersLoadingContainer>
      )}

      {!loadingUsers && (
        <DialogModifyAssignmentContentOrders users={users} {...restProps} />
      )}
    </DialogModifyAssignmentOrdersContainer>
  );
};

export default DialogModifyAssignmentOrders;
